export default "__VITE_ASSET__DzJB0Vze__"